import React from 'react'
import { Switch } from 'react-router-dom'
import List from 'app-support/wholesale/views/List'
import Edit from 'app-support/wholesale/views/Edit'
// import Detail from 'app-support/wholesale/components/old/Detail'
import { withRegionSwitchHandler } from 'core/page/withRegionSwitchHandler'
import PermissionRoute from 'app-support/permissions/PermissionRoute'
import { PERMISSION_MANAGE_WHOLESALERS } from 'app-support/permissions/Permissions'
import New from 'app-support/wholesale/views/New'
import { wholesaleRoute, wholesaleRouteEdit, wholesaleRouteList, wholesaleRouteNew } from 'routes/routeNames'

export class ModulesRoutes extends React.Component {
  public render() {
    return (
      <Switch>
        <PermissionRoute permission={PERMISSION_MANAGE_WHOLESALERS} exact path={wholesaleRouteList} component={List} />
        <PermissionRoute permission={PERMISSION_MANAGE_WHOLESALERS} exact path={wholesaleRouteNew} component={New} />
        <PermissionRoute permission={PERMISSION_MANAGE_WHOLESALERS} path={wholesaleRouteEdit} component={Edit} />
        <PermissionRoute permission={PERMISSION_MANAGE_WHOLESALERS} path={wholesaleRoute} component={List} />
      </Switch>
    )
  }
}

export default withRegionSwitchHandler('/wholesale')(ModulesRoutes)
